require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-partners-with-consulate-of-colombia.json") })
        }
      }, "path---articles-partners-with-consulate-of-colombia");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-partners-with-consulate-of-colombia!./.cache/json/articles-partners-with-consulate-of-colombia.json
// module id = 1721
// module chunks = 231608221292675